export { default as capitalize } from './capitalize';
export { default as createChainedFunction } from './createChainedFunction';
export { default as createSvgIcon } from './createSvgIcon';
export { default as debounce } from './debounce';
export { default as deprecatedPropType } from './deprecatedPropType';
export { default as isMuiElement } from './isMuiElement';
export { default as ownerDocument } from './ownerDocument';
export { default as ownerWindow } from './ownerWindow';
export { default as requirePropFactory } from './requirePropFactory';
export { default as setRef } from './setRef';
export { default as unsupportedProp } from './unsupportedProp';
export { default as useControlled } from './useControlled';
export { default as useEventCallback } from './useEventCallback';
export { default as useForkRef } from './useForkRef'; // eslint-disable-next-line camelcase

export { default as unstable_useId } from './unstable_useId';
export { default as useIsFocusVisible } from './useIsFocusVisible';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/utils/index.js
// module id = 95
// module chunks = 121